import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

//Only initialize when is called
export const storeHeader = (() => new Vuex.Store({    
    strict: true,
    namespaced: true,
    state: {
        cartQty: 0,
        cartAnim: null, // {qty: 1, msg: 'text' }
        headerMessage: { // ex PDP last order message
            show: false,
            msg: '',
            flexHeight: false,
            duration: 4000
        }
    },
    mutations: {
        setCartQty(state, payload) {
            state.cartQty = payload;
        },
        cartAnim(state, payload) {
            state.cartAnim = payload ? Object.assign({}, state.cartAnim, payload) : null;
        },
        setHeaderMessage(state, payload) {
            state.headerMessage = payload ? Object.assign({}, state.headerMessage, payload) : null;
        },
    },
    actions: {
        updateCartQty(context, payload){
            context.commit('setCartQty', payload);
        },
        updateCartQtyWithAnim(context, payload) {
            let qty = payload.qty ? payload.qty : context.state.cartQty;
            let message = payload.msg ? payload.msg : '';
            let extendMax = payload.extendMax ? payload.extendMax : false;
            //  scales dot, update qty (with transition), after 1 sec, reverse scale, then show message if available for 2 seconds then hides
           
            context.commit('cartAnim', {scaleDot: true});
            setTimeout(() => {
                context.commit('setCartQty', qty);
                context.commit('cartAnim', {hasAnim: true});
                context.commit('cartAnim', {scaleDot: false, msg: message, extendMax: extendMax});
                setTimeout(() => {
                    //context.commit('cartAnim', {msg: ''});
                    context.commit('cartAnim', {hasAnim: false});
                }, 2500);
            }, 1000);

            // total animation time
            setTimeout(() => { // after Xs, resets
                context.commit('cartAnim', null);
            }, 4500);
            
            if(qty) {
                App.js.callAppsJs('setCartItem', qty);
            }
        },
        updateHeaderMessage(context, payload){
            if(!payload) {
                context.commit('setHeaderMessage', {show: false, msg: '', flexHeight: false});
            } else {
                context.commit('setHeaderMessage', {show: true, msg: payload.msg, flexHeight: payload.flexHeight});
                setTimeout(() => {
                    context.commit('setHeaderMessage', {show: false, msg: '', flexHeight: false});
                }, context.getters.headerMessage.duration);
            }
        },
    },
    getters: {
        cartQty: state => state.cartQty,
        cartAnim: state => state.cartAnim,
        headerMessage: state => state.headerMessage,
    },
}))();
    